module.exports = __webpack_public_path__ + "static/media/maze.32e14594.jpg";